<template>
  <div>
    <div
      v-for="security in company.new_company.securities"
      :key="security.id"
      class="d-flex flex-column border-bottom pt-4"
    >
      <div
        class="d-flex mb-2"
      >
        <div>
          <span style="font-size: 18px;color: #101820;">

            {{ name(security) }}
          </span>
          <span
            class="pill  ml-1"
            :class="{
              'pill-red': security.asset_class_type_id === 1,
              'pill-green': security.asset_class_type_id === 2,
            }"
          >
            {{ security.asset_class_type_id === 1 ? 'Fixed Income' : 'Equity' }}
          </span>
        </div>
      </div>
      <form @submit.prevent="save(security)">
        <div
          class="form-group"
          v-if="security.security_code_isin"
        >
          <label
            class="text-black"
          >
            ISIN
          </label>
          <form-control
            v-model="security.security_code_isin"
            disabled
          />
        </div>
        <label class="text-black">
          Short Name
        </label>
        <div class="d-flex">
          <form-control
            style="flex-grow: 1"
            v-model="security.short_name"
          />

          <button
            class="btn btn-outline-secondary ml-4"
            style="width: 152px;"
          >
            Update
          </button>
        </div>
      </form>


      <button
        v-if="$login.can('article-drafts.publish')"
        style="width: 152px;"
        class="btn btn-outline-danger mb-3"
        @click="deleteSecurity(security)"
      >
        Delete instrument
      </button>
    </div>
    <div class="mt-5">
      <h2 style="color: #252525">
        Add Instrument manually
      </h2>
      <div class="d-flex mt-4">
        <div class="form-group w-100">
          <span class="fake-label">
            ISIN
          </span>
          <t-input
            class="mt-2"
            v-model="isin"
            :placeholder="`Add by ISIN`"
          />
        </div>
      </div>

      <div class="mt-4 py-3 d-none d-md-flex align-items-center border-top">
        <button
          @click="addByIsin"
          class="ml-auto btn btn-primary "
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {successNotification} from '@/notifications'
export default {
  props: {
    company: {
      required: true,
      type: Object,
    },
  },

  data () {
    return {
      isin: '',
    }
  },

  methods: {
    async save (security) {
      await this.$http.put(`/securities/${security.id}`, {
        short_name: security.short_name,
      })

      this.$notify(successNotification('Updated security short name.'))
    },

    async deleteSecurity (security) {
      await this.$http.delete(`/securities/${security.id}`)

      const index = this.company.new_company.securities.findIndex((s) => s.id === security.id)
      if (index !== -1) {
        this.company.new_company.securities.splice(index, 1)
      }

      this.$notify(successNotification('Deleted security.'))
    },

    name (security) {
      if (security.isregs) {
        return `${security.security_name_bbg} (regS)`
      }

      if (security.is144a) {
        return `${security.security_name_bbg} (144a)`
      }

      return security.security_name_bbg
    },

    async addByIsin () {
      await this.$http.post(`/securities/${this.isin}`, {
        companyId: this.company.id,
      })

      this.isin = ''
      this.$notify(successNotification('Please wait a couple of minutes while we process this information.'))
    },
  },

}
</script>
